import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Undo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.029.52c.339.165.554.51.554.888v8.098c5.417.603 10.423 3.305 13.75 7.255 3.524 4.112 5.2 9.537 4.743 14.61-.417 5.084-2.925 9.78-6.604 12.823a.986.986 0 0 1-1.389-.133.989.989 0 0 1 .133-1.391c3.266-2.701 5.52-6.907 5.893-11.465l.001-.008c.41-4.541-1.096-9.442-4.278-13.153l-.006-.006c-3.142-3.734-7.986-6.258-13.183-6.634a.952.952 0 0 1-.037-.003l-.119-.014a.988.988 0 0 1-.877-.982v-6.97L5.438 15.32 20.61 27.203v-6.97c0-.546.441-.988.986-.988h.049c3.142-.437 6.575.43 9.341 2.577 2.794 2.142 4.756 5.534 5.193 9.351a.988.988 0 1 1-1.96.226c-.378-3.296-2.073-6.2-4.435-8.01l-.005-.004c-2.153-1.672-4.767-2.416-7.196-2.251v8.097a.988.988 0 0 1-1.595.778L3.228 16.097a.988.988 0 0 1 0-1.556L20.988.63a.986.986 0 0 1 1.04-.11Z"
  }));
});
Undo.displayName = 'Undo';
Undo.defaultProps = {
  'aria-label': 'Undo'
};
export default Undo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Undo.js
// module id = 3940
// module chunks = 11